import { Component } from "react";

export class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-[#150E1C] px-6 text-center">
          <div>
            <p className="font-serif text-3xl text-[#F5F2EA]">Une erreur est survenue</p>
            <p className="mt-3 text-sm text-white/50">Merci de recharger la page.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
